"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackPage } from "@/lib/session";

/** Records page views against Unique ID for backend tracking */
export function UsageTracker() {
  const pathname = usePathname();
  useEffect(() => {
    if (!pathname) return;
    void trackPage(pathname, "page_view");
  }, [pathname]);
  return null;
}
